import { faCheck } from "@fortawesome/pro-regular-svg-icons";

import { useTranslation } from "react-i18next";

import { Icon } from "@/components";
import { AnswerOption, SelfAssessmentStepOption } from "@/types/self-assessment";

// Extended type to include "skip" as a selectable option
export type SelectableOption = AnswerOption | "skip";

interface SelfAssessmentOptionProps {
	selected: SelectableOption | null;
	questionId: number;
	isSubtask: boolean;
	subtaskId: string;
	todoId: number;
	industryIds?: number[];
	companySizeId?: number | null;
	companyRevenueId?: number | null;
	onSelect: (option: SelfAssessmentStepOption, isSkipSelection?: boolean) => void;
}

const options: AnswerOption[] = ["yes", "no"];

export default function SelfAssessmentOption({
	selected,
	questionId,
	isSubtask,
	subtaskId,
	todoId,
	industryIds = [],
	companySizeId = null,
	companyRevenueId = null,
	onSelect,
}: SelfAssessmentOptionProps) {
	const { t } = useTranslation();

	return (
		<div className="space-y-2">
			{options.map((option) => (
				<button
					key={option}
					className="flex w-full items-center gap-3 cursor-pointer rounded-xl p-3 bg-white border border-primary-gray-lightest"
					type="button"
					onClick={() =>
						onSelect({
							questionId,
							answer: option,
							industryIds,
							companySizeId,
							companyRevenueId,
							isSubtask,
							subtaskId,
							todoId,
							isSkipped: false,
						})
					}
				>
					{selected === option ? (
						<span className="w-5 h-5 min-w-5 rounded-full flex items-center justify-center bg-primary-blue">
							<Icon className="text-white w-[14px] h-[14px]" icon={faCheck} />
						</span>
					) : (
						<p className="w-5 h-5 min-w-5 rounded-full bg-white border-[1px] border-[#D0D5DD]"></p>
					)}
					<span className="text-[14px] font-semibold text-primary-blue-dark">
						{!isSubtask ? t(`basics.self-assessment.${option}`) : t(`basics.${option}`)}
					</span>
				</button>
			))}
			{!isSubtask && (
				<button
					key={"skip"}
					className="flex w-full items-center gap-3 cursor-pointer rounded-xl p-3 bg-white border border-primary-gray-lightest"
					type="button"
					onClick={() =>
						onSelect(
							{
								questionId,
								answer: "no",
								industryIds,
								companySizeId,
								companyRevenueId,
								isSubtask,
								subtaskId,
								todoId,
								isSkipped: true,
							},
							true
						)
					}
				>
					{selected === "skip" ? (
						<span className="w-5 h-5 min-w-5 rounded-full flex items-center justify-center bg-primary-blue">
							<Icon className="text-white w-[14px] h-[14px]" icon={faCheck} />
						</span>
					) : (
						<p className="w-5 h-5 min-w-5 rounded-full bg-white border-[1px] border-[#D0D5DD]"></p>
					)}
					<span className="text-[14px] font-semibold text-primary-blue-dark">
						{t("questionnaire.self-assessment.skip")}
					</span>
				</button>
			)}
		</div>
	);
}
